export default "__VITE_ASSET__RWKuKzn9__"